var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"remove-underline-animation"},[_c('router-link',{class:_vm.linkClass,attrs:{"to":_vm.to}},[_vm._t("default"),_vm._v("→")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }